import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'


Vue.prototype.$API_URL = 'https://apirmm.fleurdepapier.fr';
// Vue.prototype.$API_URL = 'http://localhost:8888';
// Vue.prototype.$DOCUMENTROOT_URL = 'http://localhost:5555/sites';
Vue.prototype.$DOCUMENTROOT_URL = 'https://sandbox.fleurdepapier.fr/rmm/sites';



Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/help',
    name: 'Help',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Help.vue')
  },
  {
    path: '/sites',
    name: 'ListSites',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ListSites.vue')
  },
  {
    path: '/homepage/',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/HomePageEdit.vue')
  },
  {
    path: '/sites/:id',
    name: 'EditSite',
    props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/EditSite.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
